import {
  ACTIVE_DEPLOYMENT_REGIONS,
  type ActiveDeploymentRegion,
  type DeploymentRegion,
} from "../shared-utils/serviceIdentity";

export {
  ACTIVE_DEPLOYMENT_REGIONS,
  DEPLOYMENT_REGIONS,
  deploymentRegionSchema,
} from "../shared-utils/serviceIdentity";
export type {
  ActiveDeploymentRegion,
  DeploymentRegion,
} from "../shared-utils/serviceIdentity";

export const isActiveDeploymentRegion = (
  region: string
): region is ActiveDeploymentRegion =>
  (ACTIVE_DEPLOYMENT_REGIONS as readonly string[]).includes(region);

// Canonical public app origins for each active region (OpenAPI servers, etc.).
// Catalogs must list every region, not the current deploy's SITE_URL.
export const PUBLIC_APP_ORIGIN_BY_REGION = {
  us: "https://listenlabs.ai",
  eu: "https://eu.listenlabs.com",
} as const satisfies Record<ActiveDeploymentRegion, string>;

export const getPublicAppServers = (): {
  url: string;
  description: string;
}[] =>
  ACTIVE_DEPLOYMENT_REGIONS.map((region) => ({
    url: PUBLIC_APP_ORIGIN_BY_REGION[region],
    description: `Production (${region.toUpperCase()})`,
  }));

/** Prod app origin for this stack. `missing` falls back to US. */
export const getPublicAppOriginForRegion = (
  region: DeploymentRegion
): string =>
  isActiveDeploymentRegion(region)
    ? PUBLIC_APP_ORIGIN_BY_REGION[region]
    : PUBLIC_APP_ORIGIN_BY_REGION.us;
